// components/Ads/ArticleAd.tsx - FIXED
import React from 'react';
import AdUnit from './AdUnit';
import { getAdSlot } from './adConfig';

interface ArticleAdProps {
  context?: 'header' | 'sidebar' | 'footer';
  format?: 'leaderboard' | 'rectangle';
  compact?: boolean;
}

const ArticleAd: React.FC<ArticleAdProps> = ({ 
  context = 'header',
  format = 'rectangle',
  compact = false
}) => {
  const slotId = context === 'sidebar' ? getAdSlot('sidebar') : context === 'footer' ? getAdSlot('footer') : getAdSlot('article');
  const adFormat = format === 'leaderboard' ? 'leaderboard' : 'rectangle';
  
  return (
    <div className="w-full my-4 flex justify-center">
      <AdUnit
        slot={slotId}
        format={adFormat}
        style={{
          width: compact ? '100%' : '100%',
          maxWidth: format === 'leaderboard' ? '728px' : '300px',
          backgroundColor: '#f9fafb',
        }}
      />
    </div>
  );
};

export default ArticleAd;
